import { store } from '@/appContext';

function hasDealerIdQuery(route) {
  return !!route.query.dealerIds;
}

function hasSearchQuery(route) {
  return !!route.query.query;
}

function hasDashboardDealerIdQuery(route) {
  return !!route.query.dashboardDealerIds;
}

// Keep dealer IDs or dashboard IDs in the route query between navigations
// and sync to the auctions store module for auctions filters in endpoints
async function applyDealerIdQueryString(to, from) {
  const queryString = { ...to.query };
  if (!hasDealerIdQuery(to) && hasDealerIdQuery(from)) {
    queryString.dealerIds = from.query.dealerIds;
  }

  if (!hasDashboardDealerIdQuery(to) && hasDashboardDealerIdQuery(from)) {
    queryString.dashboardDealerIds = from.query.dashboardDealerIds;
  }

  if (JSON.stringify(to.query) !== JSON.stringify(queryString)) {
    return { ...to, query: queryString };
  }

  if (hasDealerIdQuery(to)) {
    await store.dispatch('auctions/setSelectedDealership', to.query.dealerIds);
  }
  if (hasSearchQuery(to)) {
    await store.dispatch('auctions/setQuery', {
      query: to.query.query,
      moduleKey: to.name,
    });
  }
  if (hasDashboardDealerIdQuery(to)) {
    await store.dispatch('auctions/setSelectedPerformanceDealership', to.query.dashboardDealerIds);
  }
  return undefined;
}

export default applyDealerIdQueryString;
